import { render, staticRenderFns } from "./staff-choose.vue?vue&type=template&id=af8a25be&"
import script from "./staff-choose.vue?vue&type=script&lang=js&"
export * from "./staff-choose.vue?vue&type=script&lang=js&"
import style0 from "./staff-choose.vue?vue&type=style&index=0&id=af8a25be&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports